export interface MatterScopedUploadFields {
  title?: string | null;
  clientId?: string | null;
  matterId?: string | null;
  fileCount?: number | null;
}

export const isMatterScopedUploadReady = (fields: MatterScopedUploadFields): boolean => {
  return Boolean(
    fields.fileCount &&
      fields.fileCount > 0 &&
      fields.title?.trim() &&
      fields.clientId?.trim() &&
      fields.matterId?.trim(),
  );
};

export const getMatterScopedUploadMissingFields = (fields: MatterScopedUploadFields): string[] => {
  const missing: string[] = [];
  if (!fields.fileCount || fields.fileCount <= 0) missing.push('file');
  if (!fields.title?.trim()) missing.push('title');
  if (!fields.clientId?.trim()) missing.push('client');
  if (!fields.matterId?.trim()) missing.push('matter');
  return missing;
};
